import * as React from 'react'
import { useBrandingSettings } from 'hooks/branding'
import {
  EmptyState,
  EmptyStateFlex,
  EmptyStateIllustrationImage,
} from 'components/EmptyState'
import Button from 'components/Button'

interface ClientUserManagementEmptyStateProps {
  /**
   * Whether a search filter is applied or not.
   */
  isSearchFilterApplied: boolean
  /**
   * Callback for clearing the search filter.
   */
  onClearSearchFilterClick: () => void
}

export default function ClientUserManagementEmptyState({
  isSearchFilterApplied,
  onClearSearchFilterClick,
}: ClientUserManagementEmptyStateProps) {
  const { corporateMode } = useBrandingSettings()

  const title = isSearchFilterApplied
    ? "We couldn't find what you were looking for."
    : 'No results found'

  const subtitle = isSearchFilterApplied ? (
    <>
      Maybe try{' '}
      <Button type="text" size="baseline" onClick={onClearSearchFilterClick}>
        clearing your search filter
      </Button>{' '}
      ?
    </>
  ) : (
    ''
  )

  return (
    <EmptyStateFlex>
      <EmptyState
        small
        animate
        hideIllustration={corporateMode}
        title={title}
        subtitle={subtitle}
        image={
          <EmptyStateIllustrationImage
            src={require('assets/images/img_empty.svg')}
          />
        }
      />
    </EmptyStateFlex>
  )
}
